import {defineStore} from 'pinia';
import {ModuleBudgetKindItem} from '../moduleConst';
import budgetKindItemAPI from '@/apis/di/budgetKindItemAPI';
import {BaseDictionaryStore} from '@/stores/baseDictionaryStore';
const budgetKindItemStore = new BaseDictionaryStore(budgetKindItemAPI);
export const useBudgetKindItemStore = defineStore(ModuleBudgetKindItem, {
  state: () => ({
    ...budgetKindItemStore.state,
    _config: {
      key: 'budget_kind_item_id',
      code: 'budget_kind_item_code',
      name: 'budget_kind_item_name',
      table: 'di_budget_kind_item',
      moduleName: 'Loại khoản',
      defaultSort: 'budget_kind_item_code',
      quickFollow: 'active',
      isTree: true, // thêm trường này để khi sửa loại cha thì load lại trên grid
    },
    moduleName: 'budgetKindItem',
  }),
  actions: {
    ...budgetKindItemStore.action,
    /**
     *  cập nhật phát sinh loại khoản
     * @author nnninh 02/06/2023
     * @param {*} context
     * @param {*} payload
     * @returns
     */
    async updateBudgetKindItemsData(payload) {
      const res = await budgetKindItemAPI.updateBudgetKindItemsData(payload || {});
      return res;
    },
  },
  getters: {
    ...budgetKindItemStore.getters,
  },
});
